/**
 * MentionSpanOffsetTracker:

 * We're using Draft.js decorators to render a <span> around each @mention. That leaves
 * us with a block containing:
 *
 * <div data-offset-key="btpje-0-0">
 *   <span data-offset-key="btpje-0-0">Lorem</span>
 *   <span data-offset-key="btpje-1-0"> @ipsum</span>
 *   <span data-offset-key="btpje-2-0"> dolor</span>
 * </div>
 *
 * So, in order detect if the selection is within one of those rendered <span>s, we need to track
 * the `offsetKey` that Draft assigns to 'em, and based on that, we'll know if we should display
 * some portal offering suggestions for such query. This makes the whole process much easier and
 * safe when it comes to detecting the selection (cursor) within those mentions.
 */

const MentionSpanOffsetTracker = {
  /**
   * @private
   * @param {[]String}
   */
  _offsetKeys: [],

  /**
   * @param {String} offsetKey
   */
  putOffsetKey: function putOffsetKey(offsetKey) {
    this._offsetKeys = this._offsetKeys.concat(offsetKey);
  },

  /**
   * @param {String} offsetKey
   */
  delOffsetKey: function delOffsetKey(offsetKey) {
    this._offsetKeys = this._offsetKeys.filter(
      maybeOffsetKey => offsetKey !== maybeOffsetKey,
    );
  },

  /**
   * @returns {[]String}
   */
  getOffsetKeys: function getOffsetKeys() {
    return this._offsetKeys;
  },

  reset: function reset() {
    this._offsetKeys = [];
  },
};

export default MentionSpanOffsetTracker;
